/**************
 Product Swiper
 **************/

// options for all swipers

document.querySelectorAll('.reasonsPDPVisualSwiper').forEach(swiper => {

    const swiperItem = new Swiper(swiper, {
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: true,
    });

    // get the coupled thumbnails
    const thumbs = document.querySelector(`.reasonsPDPVisualThumbs[data-variant="${swiper.dataset.variant}"]`) || null;

    if (thumbs) {
        // update the thumbnail active class
        swiperItem.on('slideChange', function () {
            thumbs.querySelector(".reasonsPDPVisualThumbsSlide.active")?.classList.remove("active");
            thumbs.querySelectorAll(".reasonsPDPVisualThumbsSlide")[this.realIndex].classList.add("active");
        });

        // // change slide on thumbnail click
        thumbs.querySelectorAll(".reasonsPDPVisualThumbsSlide").forEach(el => {
            el.addEventListener("click", function () {
                // change slide
                swiperItem.slideTo(this.dataset.index - 1);
            });
        });
    }
})

/**********************
 * Product Subscription
 **********************/
// check for subscription option and gather ID
let hasSubscription = !!document.querySelector('.reasonsPDPSubscriptionOptionInput[value="sub"]:checked') || !!document.querySelector('.reasonsPDPSubscriptionOptionInput[value="double"]:checked');
let subscriptionID = document.querySelector(".reasonsPDPSubscriptionOptionInput")?.dataset.subscription;

/****************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll(".reasonsPDP input").forEach(function (element) {
    element.addEventListener("change", function () {
        const color = this.dataset.color;
        // up text colors - announcement text, prices, otp text
        document.querySelectorAll('.reasonsPDPSubscriptionOptionPrice, .reasonsPDPSubscriptionOptionSubtitle')?.forEach(el => {
            el.style.color = color;
        })

        // up discount pill colors
        document.querySelectorAll('.reasonsPDPSubscriptionOptionPercent')?.forEach(el => {
            el.style.backgroundColor = color;
        })

        // update messaging
        if (document.querySelector('.reasonsPDPSubscriptionPromo')) {
            document.querySelector('.reasonsPDPSubscriptionPromo').style.color = color;
        }

        // if otp selected, hide text & button
        if (this.name === 'purchase-option') {
            this.value === "otp"
                ? document.querySelector('.reasonsPDPSubCTAWrap').style.gridTemplateRows = "0fr"
                : document.querySelector('.reasonsPDPSubCTAWrap').style.gridTemplateRows = "1fr";
        }

        // check if marked sold out via metafield
        let soldOut = document.querySelector('.reasonsPDPOptionItemValuesLabelInput:checked').classList.contains('soldOut');
        updateProduct(soldOut);
    });
})

// mobile option selector
document.querySelector('.reasonsPDPOptionMobileSelected')?.addEventListener('click', function (e) {
    // if dropdown is open and option is selected, swap flavors
    if (e.target.classList.contains('reasonsPDPOptionMobileListItem')) {
        // click on input to begin swapping of content
        document.querySelector(`.reasonsPDPOptionItemValuesLabelInput[data-variant="${e.target.dataset.variant}"]`).click();
        // update active on button
        this.querySelector('.reasonsPDPOptionMobileSelectedItem .reasonsPDPOptionMobileOptionColor').style.backgroundColor = e.target.dataset.color;
        this.querySelector('.reasonsPDPOptionMobileSelectedItem .reasonsPDPOptionMobileOptionTitle').textContent = e.target.querySelector('.reasonsPDPOptionMobileOptionTitle').textContent;
        // hide active from dropdown and show former active
        document.querySelector('.reasonsPDPOptionMobileListItem.hidden').classList.remove('hidden');
        e.target.classList.add('hidden');
        // close dropdown
        this.classList.remove('active');
    } else {
        this.classList.toggle('active');
    }
})

// update active variant
function updateProduct(soldOut = false) {
    // if only one variant skip finding variant
    if (product.variants.length > 1) {
        // collect options from inputs
        let options = [];
        document.querySelectorAll(`.reasonsPDPOptionItem`).forEach(group => {
            options.push(group.querySelector(`input:checked`).value);
        });

        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });

        // check if variant wasn't found
        if (activeVariant === null || activeVariant === undefined) {
            document.querySelectorAll(".reasonsPDPATC").forEach(el => el.disabled = true);
            document.querySelectorAll(".reasonsPDPATC").forEach(el => el.textContent = "Not Available");
            return;
        }
    }

    // update variant title
    if (document.querySelector('.reasonsPDPTitlesVariant')) {
        document.querySelectorAll('.reasonsPDPTitlesVariant').forEach(el => el.textContent = activeVariant.title);
    }

    // update variant slider images
    // hide existing active
    document.querySelector('.reasonsPDPVisualSwiper.active')?.classList.remove('active');
    document.querySelector('.reasonsPDPVisualThumbs.active')?.classList.remove('active');
    // reveal matching media
    document.querySelector(`.reasonsPDPVisualSwiper[data-variant="${activeVariant.id}"]`).classList.add('active');
    document.querySelector(`.reasonsPDPVisualThumbs[data-variant="${activeVariant.id}"]`).classList.add('active');

    // update subscription status
    hasSubscription = !!document.querySelector('.reasonsPDPSubscriptionOptionInput[value="sub"]:checked') || !!document.querySelector('.reasonsPDPSubscriptionOptionInput[value="double"]:checked');

    // enable atc buttons
    document.querySelectorAll(".reasonsPDPATC").forEach(el => el.disabled = false);

    // check if the variant is in stock or needs special messaging
    if (document.querySelector(`.reasonsPDPBuying span[data-id="${activeVariant.id}"]`)) {
        // remove soldOut attributes
        document.querySelectorAll(".reasonsPDPATC").forEach(el => {
            el.textContent = "PRE-ORDER NOW";
            el.classList.remove('soldOut');
        });
        // update the purchase options
        if (document.querySelector('.reasonsPDPSubscriptionOptionInput[value="sub"] + .reasonsPDPSubscriptionOptionInner .reasonsPDPSubscriptionOptionTitle')) {
            document.querySelector('.reasonsPDPSubscriptionOptionInput[value="sub"] + .reasonsPDPSubscriptionOptionInner .reasonsPDPSubscriptionOptionTitle').textContent = "PRE-ORDER 30 DAY BOX"
        }
        if (document.querySelector('.reasonsPDPOnceTitle')) {
            document.querySelector('.reasonsPDPOnceTitle').textContent = "PRE-ORDER ONE TIME"
        }
    } else if (activeVariant.available && !soldOut) {
        // remove soldOut class
        document.querySelectorAll(".reasonsPDPATC").forEach(el => el.classList.remove('soldOut'));
        document.querySelector(".reasonsPDPATC.reasonsPDPATCPrimary").textContent = "Add To Cart";
        if (document.querySelector(".reasonsPDPATC.reasonsPDPOnceHiddenAtc")) {
            document.querySelector(".reasonsPDPATC.reasonsPDPOnceHiddenAtc").textContent = "Add To Cart";
        }
        // update the purchase options
        if (document.querySelector('.reasonsPDPSubscriptionOptionInput[value="sub"] + .reasonsPDPSubscriptionOptionInner .reasonsPDPSubscriptionOptionTitle')) {
            document.querySelector('.reasonsPDPSubscriptionOptionInput[value="sub"] + .reasonsPDPSubscriptionOptionInner .reasonsPDPSubscriptionOptionTitle').textContent = "30 DAY BOX"
        }
        if (document.querySelector('.reasonsPDPOnceTitle')) {
            document.querySelector('.reasonsPDPOnceTitle').textContent = "BUY ONE TIME"
        }
    } else {
        // add soldOut attributes
        document.querySelectorAll(".reasonsPDPATC").forEach(el => {
            el.textContent = "Sold Out - Notify Me When Available";
            el.classList.add('soldOut');
        });
        // update the purchase options
        if (document.querySelector('.reasonsPDPSubscriptionOptionInput[value="sub"] + .reasonsPDPSubscriptionOptionInner .reasonsPDPSubscriptionOptionTitle')) {
            document.querySelector('.reasonsPDPSubscriptionOptionInput[value="sub"] + .reasonsPDPSubscriptionOptionInner .reasonsPDPSubscriptionOptionTitle').textContent = "30 DAY BOX"
        }
        if (document.querySelector('.reasonsPDPOnceTitle')) {
            document.querySelector('.reasonsPDPOnceTitle').textContent = "BUY ONE TIME"
        }
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

/***********
 Product ATC
 ***********/

document.querySelectorAll(".reasonsPDPATC")?.forEach(el => {
    el.addEventListener("click", async function () {

        // check for out of stock
        if (this.classList.contains("soldOut")) {
            // check email
            let {value: email} = await Swal.fire({
                title: `${product.title} / ${activeVariant.title}`,
                text: "Enter your email to be notified when this product is back in stock.",
                input: "email",
                inputPlaceholder: "Email Address",
                confirmButtonText: "Notify Me When Available",
            });

            // confirm email is returned
            if (!email) {
                return;
            }

            // add to waitlist
            await sendKlaviyoBackInStockRequest(email, activeVariant.id);

            // show success message
            await Swal.fire({
                title: "Success!",
                text: "You will be notified when this product is back in stock.",
                confirmButtonText: "OK",
            });

            return;
        }

        // add loading animation
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: 1,
                id: activeVariant.id,
                // if subscription is chosen, use active id
                selling_plan: hasSubscription ? subscriptionID : null
            }]
        };

        // if it's a subscription, and sampler is not already in cart, add it
        if (product.handle === "premium-electrolyte-drink-mix" && hasSubscription && !cart.items.find(item => item.variant_id === samplerVariantID)) {
            formData.items.push({
                quantity: 1,
                id: samplerVariantID
            });
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open checkout
        window.location.href = "/checkout";
    });
})

/******
 Other
 *****/

// check if discount code is present
if (Cookies.get("discount_code")) {
    // set the discount code text
    document.querySelector("#reasonsPDPCouponfield").textContent = `${Cookies.get("discount_code").toUpperCase()} applied at checkout`;

    // show the discount code element
    document.querySelector("#reasonsPDPCouponfield").classList.add("active");
}